import _axios from "libs/axios";

export interface NewsletterSubscribeDto {
  email: string;
  firstName?: string;
  lastName?: string;
  tags?: string[];
}

export interface SubscriptionResponse {
  success: boolean;
  message: string;
}

export class NewsletterRepository {
  constructor() {}

  static async subscribe(body: NewsletterSubscribeDto) {
    return new Promise<SubscriptionResponse>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post<SubscriptionResponse>(
          "/v1/auth/newsletter/subscribe",
          body
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
}
